import { registerBlockType, getBlockType } from '@wordpress/blocks';
import { InspectorControls, InnerBlocks, useBlockProps } from '@wordpress/block-editor';
import { PanelBody, ToggleControl } from '@wordpress/components';
import classNames from 'classnames';


if(!getBlockType('preciseinvestigation/hero-slider')) {
  registerBlockType('preciseinvestigation/hero-slider', {
    title: 'preciseinveatigationHero Slider',
    icon: 'pets',
    category: 'preciseinvestigation',
    supports: {
      align: true,
      align: ['wide', 'full']
    },
    attributes: {
      align: {
        type: 'string',
        default: 'full'
      },
      darkMode: {
        type: 'boolean',
        default: false,
      }
    },
    edit: (props) => editComponent(props),
    save: (props) => saveComponent(props),
  });
}

function editComponent({attributes, setAttributes}) {
  const ALLOWED_BLOCKS = [ 'lazer-kitty/hero-slider-slide' ];
  const blockProps = useBlockProps();
  const { darkMode } = attributes;
  return (
    <>
      <InspectorControls>
        <PanelBody title="Settings">
          <ToggleControl
            label="Toggle darkmode"
            help="Changes slider pagination colour for dark backgrounds. Only visible on front end."
            checked={darkMode}
            onChange={() => setAttributes({ darkMode: !darkMode })}
          />
        </PanelBody>
      </InspectorControls>
      <section { ...blockProps }>
        <InnerBlocks allowedBlocks={ ALLOWED_BLOCKS } orientation="horizontal" />
      </section>
    </>
  );
}

function saveComponent({attributes}) {
  const blockProps = useBlockProps.save();
  const { darkMode } = attributes;
  return (
    <section { ...blockProps } className={classNames('splide', {'dark': darkMode})}>
      <div className="splide__track">
        <ul className="splide__list">
          <InnerBlocks.Content />
        </ul>
      </div>
    </section>
  );
}